module.exports = __webpack_public_path__ + "img/yervant.b54086a0.jpg";